/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const ON_KEY_EVENT = 'ON_KEY_EVENT';
export const ON_MOUSE_EVENT = 'ON_MOUSE_EVENT';
export const CLEAR_KEY_EVENT = 'CLEAR_KEY_EVENT';
